import { render, staticRenderFns } from "./AdsAndOffers-details.vue?vue&type=template&id=1f9fa854&scoped=true&"
import script from "./AdsAndOffers-details.vue?vue&type=script&lang=js&"
export * from "./AdsAndOffers-details.vue?vue&type=script&lang=js&"
import style0 from "./AdsAndOffers-details.vue?vue&type=style&index=0&id=1f9fa854&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9fa854",
  null
  
)

export default component.exports